import { FEATURES, hasFeature } from '@/features/feature-flags';
import { userStore } from '@/stores/user.store';

/** Whether this account may have proactive agents; the backend checks the same rule */
export const canUseProactiveAgent = () =>
  userStore.isInternalUser || hasFeature(FEATURES.PROACTIVE_AGENT);
